import { createAction, props } from '@ngrx/store';
import { Payment } from '../_models';

// Action types
export const loadPayments = createAction('[Payment] Load Payments');
export const loadpaymentsSuccess = createAction(
  '[Payment] Load Payments Success',
  props<{ payments: Payment[] }>()
);
export const loadpaymentsFailure = createAction(
  '[Payment] Load Payments Failure',
  props<{ error: any }>()
);
